import React from 'react'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import TechnologyHead from '../techComponent/TechnologyHead'
import TechnologyNex from '../techComponent/TechnologyNex';

const breadcrumbData = [
  {
    page: "Home",
    slug: "/",
  },
  {
    page: "Technologies",
    slug: "",
  },
  {
    page: " Data & Analytics",
    slug: "",
  }
]

const techData = {
  label: "Technologies",
  heading: "Data & Analytics: Leverage Actionable Insights with Secure, Smart & Scalable Document Management Solutions",
  img: "/assets/images/data-anali-banner.webp",
  alt: "Data & Analytics",
  description: `
    <p>Record management or data management is one of the essential demands in recent times. It is necessary and compulsory to keep data safe as documents are the basic foundation of any business. Scalable data analysis is an important aspect of the record management system which helps in inspecting, cleansing, managing, and transforming data into useful information. The modelling of data is also a part of this process which helps the business to operate more effectively.</p>

    <p>Dox and Box is a prominent Records Management Company which provides clients with a convenient one-stop-shop experience in the record management system. We help our clients to improve internal operational visibility. The document management software works diligently and makes its way into the industry.
    We provide the service of data analysis using the supervision and administration of digital or paper records regardless of the format. It doesn't matter that records belong to which industry as the analysis of documents helps every institution to maintain data of every transaction, activity, decision. Data analysis can improve the efficiency of any company and keep them updated.</p>

    <p>Record Management also allows the real-time analysis of data. We provide multiple facets of data analysis and approaches. There are several techniques which help in enabling one to access and explore large volumes of complex and diverse data.</p>

    <p>At Dox and Box, we provide the service of data and analytics tools that will help in making great business decisions. The companies can get better results when analytics practices in the best way. The correct way of management and preparation of large data for analytics can help the companies. With the help of data analytics tools, the relation between information governance and business needs can be maintained.</p>

    <p>Our data professionals employ advanced data sciences to solve complex business challenges. With their expertise and experience, they can generate analytics of real-time data and help their client to navigate the complexities of a hybrid data. The data of various verticals can get integrated in the best possible way. It allows our clients to verify, find, access the data without any hassle.</p>

    <p>Data management system enables organizations to use data analytics in beneficial ways. Data analysis helps in optimizing the operations and eventually leads to the success of the business brilliantly. The advantages of data analysis are:</p>

    <h2>Smart Solutions</h2>
    <p>Smart Solutions for document management by Dox and Box leverage advanced data and analytics to transform information into actionable insights for smarter decision-making, enabling real-time data processing, detailed reporting, performance tracking to enhance operational efficiency and accuracy while ensuring better visibility, control, a more optimized document management ecosystem.</p>

    <ul>
      <li>Personalizing the customer experience</li>

      <li>Adding value to customer interactions</li>

      <li>Classifying the root causes of marketing failures and business issues in real-time</li>

      <li>Reaping the revenues associated with data-driven marketing</li>

      <li>Increasing customer engagement</li>

      <li>Enhancing customer loyalty</li>
    </ul>
   
    <p>We deliver exceptional service with a focus on quality data analysis which offers fast, secure, reliable data. At Dox and Box, we offer analytics resources and with the help of our leading experts and professionals, we help our clients to prepare for successful adoption and implementation of data analytics.</p>
   
  `
};

const techNextData = [
  {
    img: "assets/images/data-analist-one.webp",
    title: "Data integration & visibility",
    slug: "/data-integration-visibility"
  },
  {
    img: "/assets/images/data-analist-two.webp",
    title: "IOT Enabled System",
    slug: "/iot-enabled"
  },
];

export default function DataAnalytics() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <TechnologyHead data={techData} />
      <TechnologyNex technex={techNextData} />
    </>
  )
}
